import React, { useEffect, useState } from "react";
import { getProjects } from "../ApiServices/AuthService";
import Pagination from "./Pagination";
import Navbar from '../Components/Navbar';
import Spinner from './Spinner';

const Card = () => {
  const [projectData, setProjectData] = useState([]);
  const [expandedCard, setExpandedCard] = useState(-1); // Default: no card expanded

  const [currentPage , setCurrentPage] = useState(1);
  const [cardPerPage] = useState(6);
  const [currentCard,setCurrentCard] = useState([])
  const [isAdmin , setIsAdmin] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);



useEffect(() =>{
  fetchData();
},[])

useEffect(() => {
  if (projectData) {
      const indexOfLastCard = currentPage * cardPerPage;
      const indexOfFirstCard = indexOfLastCard - cardPerPage;
      setCurrentCard(projectData.slice(indexOfFirstCard, indexOfLastCard));
  }
}, [projectData, currentPage, cardPerPage]);

const handleSearchResults = (data) => {
  setProjectData(data);
  setCurrentPage(1); // Reset to the first page after search
}

const handleAllResult = () => {
  fetchData();
  setCurrentPage(1); // Reset to the first page after search
}

useEffect(() => {

  if(localStorage.getItem("email") == "hargun0360@gmail.com" || localStorage.getItem("email") == "hargunbit1001@gmail.com"){
    setIsAdmin(true);
  }
  
},[]);

 

const paginate = (pageNumber) =>{
  setCurrentPage(pageNumber)
}

const fetchData = () => {
   setShowSpinner(true);
  getProjects().then((res) => { 
    setShowSpinner(false);
    if (res.data === "Please Upload the data") {
      setIsEmpty(true);
    } else {
      setShowSpinner(false);
      setIsEmpty(false);
      setProjectData(res.data);
    }
  });
};


  return (<React.Fragment>
     {showSpinner && <Spinner />}
     <Navbar isAdmin={isAdmin} onSearchResults={handleSearchResults} onCross={handleAllResult}/>
     <div className='Project-Cards'>
      {isEmpty ? (
        <div className="empty-message" style={{height:"100vh",width:"100vw", display:"flex",justifyContent:"center",alignItems:"center",fontWeight:"600",fontSize:"24px"}}>
          Please upload the file and then see the cards.
        </div>
      ) : (currentCard && currentCard.length > 0 ? currentCard.map((item , index) => {
        const isExpanded = expandedCard === index;
        return (
          <div key={item.id} className="Card">
            <div className="Card-title">
              <h2>{item.Title}</h2>
            </div>
            <h4>Technologies</h4>
            <div className="Card-Technologies">
              {item.Technologies && item.Technologies.length > 0 ? item.Technologies.slice(0, isExpanded ? undefined : 5).map((tech, idx) => (
                <div key={idx} className="card-style">{tech}</div>
              )) : <div className="text-style"> Not Specified </div>}
              {!isExpanded && item.Technologies.length > 5 && <div>...</div>}
            </div>
            
            {isExpanded && (
              <>
                <h4>Frontend</h4>
                <div className="Card-Frontend">
                  {item.Frontend && item.Frontend.length > 0 ? item.Frontend.map((tech, idx) => (
                    <div key={idx} className="card-style">{tech}</div>
                  )): <div className="text-style"> Not Specified </div>}
                </div>

                <h4>Backend</h4>
                <div className="Card-Backend">
                  {item.Backend && item.Backend.length > 0 ? item.Backend.map((tech, idx) => (
                    <div key={idx} className="card-style">{tech}</div>
                  )): <div className="text-style"> Not Specified </div>}
                </div>

                <h4>Databases</h4>
                <div className="Card-Databases">
                  {item.Databases && item.Databases.length > 0 ? item.Databases.map((tech, idx) => (
                    <div key={idx} className="card-style">{tech}</div>
                  )): <div className="text-style"> Not Specified </div>}
                </div>

                <h4>Infrastructure</h4>
                <div className="Card-Infrastructure">
                  {item.Infrastructure && item.Infrastructure.length > 0 ? item.Infrastructure.map((tech, idx) => (
                    <div key={idx} className="card-style">{tech}</div>
                  )): <div className="text-style"> Not Specified </div>}
                </div>

                <h4>Other Information</h4>
                <div className="Card-Infrastructure">
                <div className="text-style"> {item.Availability} </div>
                </div>
              </>
            )}

            <button onClick={() => setExpandedCard(isExpanded ? -1 : index)}>
              {isExpanded ? 'View Less' : 'View More'}
            </button>
          </div>
        );
      }) : <Spinner />)}
      </div>
      <br></br>
      <br></br>
      {projectData && projectData.length > 0 ? <Pagination 
        cardsPerPage={cardPerPage}
        totalCards = {projectData.length}
        paginate = {paginate}
      /> : null}
      <br></br>
   </React.Fragment>);
};

export default Card;
